import { API, Endpoints } from "@brg/api";
import { useEffect, useState } from "react";

export const useGetSellers = (profile?: any) => {
  const [sellers, setSellers] = useState<any>();

  useEffect(() => {
    if (profile) {
      API.fetch(`${Endpoints.economics}/api/sellers/owned`, { method: "GET" })
        .then((r) => r.json())
        .then((json) => setSellers(json));
    }
  }, [profile]);

  return sellers;
};
import { API, Endpoints } from "@brg/api";
import { useEffect, useState } from "react";

export const useGetSellers = (profile?: any) => {
  const [sellers, setSellers] = useState<any>();

  useEffect(() => {
    if (profile) {
      API.fetch(`${Endpoints.economics}/api/sellers/owned`, { method: "GET" })
        .then((r) => r.json())
        .then((json) => setSellers(json));
    }
  }, [profile]);

  return sellers;
};
